import React from 'react';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { AndroidOutlined } from '@material-ui/icons';

// Icons
import Lines from "../Icons/Lines-removebg-preview.png"
import Spot from "../Icons/Spot-removebg-preview.png"
import Chest from "../Icons/Chest-removebg-preview.png"
import GridContainer from 'components/Grid/GridContainer';

export default function ToggleButtonThreeB() {
  const [alignment, setAlignment] = React.useState('left');

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
    >
      

      
          <ToggleButton style={{width:"410px"}} value="left">
            <img width="60" height="60" src={Lines} alt="fireSpot"/>   
            <p>Conservative Strategy (Safe & Slow)</p>
            {/* <p  style={{fontSize:"10px"}}>Waits for the most opportune time to start a new deal</p> */}
          </ToggleButton>
          <ToggleButton style={{width:"410px"}} value="center">
            <img width="60" height="60" src={Spot} alt="fireSpot"/>  
            Moderate
          </ToggleButton>
          <ToggleButton style={{width:"410px"}} value="right">
            <img width="60" height="60" src={Chest} alt="fireSpot"/>  
            Aggressive (Reskier & Fast)
          </ToggleButton>
          
        </ToggleButtonGroup>
  );
}